import { routeList } from '@/router/helpers/routes'
/* Views */
import Profile from '@/views/userArea/Profile'
import DefinitionsActiveChannels from '@/views/userArea/definitions/ActiveChannels'
import DefinitionsPasswordChange from '@/views/userArea/definitions/PasswordChange'
import DefinitionsFriendlyUsername from '@/views/userArea/definitions/FriendlyUsername'
import DefinitionsHistory from '@/views/userArea/definitions/History'
import DefinitionsSecureAssociationEnrollment from '@/views/userArea/definitions/SecureAssociationEnrollment'
import DefinitionsNotifications from '@/views/userArea/definitions/Notifications'
import ThirdLevelMenu from '@/views/ThirdLevelMenu'
import UnderDevelopment from '@/views/UnderDevelopment'

export default [{
	path: routeList.USER_AREA_BASE_PATH,
	beforeEnter (to, from, next) {
		next(false)
	}
}, {
	path: routeList.USER_AREA_PROFILE_PATH,
	name: routeList.USER_AREA_PROFILE_NAME,
	component: Profile
},
/* ***********************************************
*                    DEFINITIONS                 *
*********************************************** */
{
	path: routeList.USER_AREA_DEFINITIONS_PATH,
	name: routeList.USER_AREA_DEFINITIONS_NAME,
	component: ThirdLevelMenu
}, {
	path: routeList.USER_AREA_DEFINITIONS_ACTIVE_CHANNELS_PATH,
	name: routeList.USER_AREA_DEFINITIONS_ACTIVE_CHANNELS_NAME,
	component: DefinitionsActiveChannels
}, {
	path: routeList.USER_AREA_DEFINITIONS_PASSWORD_CHANGE_PATH,
	name: routeList.USER_AREA_DEFINITIONS_PASSWORD_CHANGE_NAME,
	component: DefinitionsPasswordChange
}, {
	path: routeList.USER_AREA_DEFINITIONS_FRIENDLY_USERNAME_PATH,
	name: routeList.USER_AREA_DEFINITIONS_FRIENDLY_USERNAME_NAME,
	component: DefinitionsFriendlyUsername
}, {
	path: routeList.USER_AREA_DEFINITIONS_ACCOUNTS_GROUPS_PATH,
	name: routeList.USER_AREA_DEFINITIONS_ACCOUNTS_GROUPS_NAME,
	component: UnderDevelopment
}, {
	path: routeList.USER_AREA_DEFINITIONS_HISTORY_PATH,
	name: routeList.USER_AREA_DEFINITIONS_HISTORY_NAME,
	component: DefinitionsHistory
}, {
	path: routeList.USER_AREA_DEFINITIONS_SECURE_ASSOCIATION_ENROLLMENT_PATH,
	name: routeList.USER_AREA_DEFINITIONS_SECURE_ASSOCIATION_ENROLLMENT_NAME,
	component: DefinitionsSecureAssociationEnrollment
}, {
	path: routeList.USER_AREA_DEFINITIONS_NOTIFICATIONS_PATH,
	name: routeList.USER_AREA_DEFINITIONS_NOTIFICATIONS_NAME,
	component: DefinitionsNotifications
}]
